module.exports = __webpack_public_path__ + "img/megamenu-img.913183e4.png";